import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { TreePage } from './pages/TreePage';
import { PersonPage } from './pages/PersonPage';
import { ToastProvider } from './components/ui/Toast';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          {/* Skip to main content - accessibility */}
          <a href="#main-content" className="skip-link">
            Bỏ qua điều hướng
          </a>
          <main id="main-content">
            <Routes>
              <Route path="/" element={<Navigate to="/tree" replace />} />
              <Route path="/tree" element={<TreePage />} />
              <Route path="/person/:id" element={<PersonPage />} />
            </Routes>
          </main>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;

